import {
	AnalyticsAction,
	AnalyticsActionSubject,
	AnalyticsActionSubjectId,
	ScopeState,
} from '../../types';
import { BaseInvitePeopleAnalytics } from '../../analytics';

export const NO_SCOPE_MESSAGE = 'noScopeMessage';
export const PARTIAL_SCOPE_MESSAGE = 'partialScopeMessage';
const THIRD_PARTY_DROPDOWN_MENU = 'thirdPartyDropdownMenu';
const SLACK_CONNECT_MODAL = 'slackConnectModal';

export const ACTION_SUBJECT_IDS = {
	ADD_NOW: 'addNow',
	ADD_SLACK_ACCOUNTS: 'addSlackAccounts',
	DISCONNECT: 'disconnect',
	DONE: 'done',
	INTEGRATION_SETTINGS: 'integrationSettings',
	MAYBE_LATER: 'maybeLater',
	SHOW_ME_HOW: 'showMeHow',
};

export class ThirdPartyAnalytics extends BaseInvitePeopleAnalytics {
	updateConnectionShown(serviceKey: string, scope: ScopeState) {
		const name = scope === ScopeState.NO_SCOPE ? NO_SCOPE_MESSAGE : PARTIAL_SCOPE_MESSAGE;

		this.fireScreen({ name, attributes: { integration: serviceKey } });
	}

	updateWarningClicked(serviceKey: string, orgId: string | null, scopeState: ScopeState) {
		this.fireUI({
			actionSubject: AnalyticsActionSubject.LINK,
			actionSubjectId: AnalyticsActionSubjectId.UPDATE_WARNING,
			action: AnalyticsAction.CLICKED,
			attributes: { integration: serviceKey, orgId, scopeState },
		});
	}

	scopeUpdateButtonClicked(serviceKey: string, scopeState?: ScopeState) {
		this.fireUI({
			actionSubject: AnalyticsActionSubject.BUTTON,
			actionSubjectId: AnalyticsActionSubjectId.CONTINUE_UPDATE,
			action: AnalyticsAction.CLICKED,
			attributes: { integration: serviceKey, scopeState },
		});
	}

	integrationSettingsButtonClicked(serviceKey: string, orgId: string | undefined) {
		this.fireUI({
			actionSubject: AnalyticsActionSubject.BUTTON,
			actionSubjectId: ACTION_SUBJECT_IDS.INTEGRATION_SETTINGS,
			action: AnalyticsAction.CLICKED,
			attributes: { integration: serviceKey, orgId },
		});
	}

	thirdPartyDropdownMenuShown(thirdParty: string, orgId: string) {
		this.fireScreen({
			name: THIRD_PARTY_DROPDOWN_MENU,
			attributes: { thirdParty, orgId },
		});
	}

	slackConnectModalShown() {
		this.fireScreen({ name: SLACK_CONNECT_MODAL });
	}

	slackDoneButtonClicked(teamId: string) {
		this.fireUI({
			actionSubject: AnalyticsActionSubject.BUTTON,
			actionSubjectId: ACTION_SUBJECT_IDS.DONE,
			action: AnalyticsAction.CLICKED,
			attributes: { selectedTeamId: teamId },
		});
	}

	slackDisconnectButtonClicked(teamId: string) {
		this.fireUI({
			actionSubject: AnalyticsActionSubject.BUTTON,
			actionSubjectId: ACTION_SUBJECT_IDS.DISCONNECT,
			action: AnalyticsAction.CLICKED,
			attributes: { selectedTeamId: teamId },
		});
	}

	connectButtonClicked(serviceKey: string) {
		this.fireUI({
			actionSubject: AnalyticsActionSubject.BUTTON,
			actionSubjectId: AnalyticsActionSubjectId.CONNECT,
			action: AnalyticsAction.CLICKED,
			attributes: {
				integration: serviceKey,
				source: this.commonAttributes.source,
				product: this.commonAttributes.productId,
			},
		});
	}
}
